<ng-container *ngTemplateOutlet="{'default': default, 'custom': custom }[getTemplate()]"></ng-container>

<ng-template #default>
    <mat-icon>{{getIcon()}}</mat-icon>
</ng-template>

<ng-template #custom>
    <img [src]="getIcon() | cdn" alt="">
</ng-template>